import React from "react"
import illustration from '../images/illustrazione-capitolo-4.svg'
import frecciaWhite from '../images/freccia-white.svg'

const Page14 = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-5'>
        <div className='lg:mt-13 xl:mt-11 font-uppercase font-18 line-height-22'>
          COME FUNZIONA FLEET AUDIT
        </div>
        <div className='mt-3 lg:font-62 xl:font-50 font-family-acumin lg:line-height-70 xl:line-height-58 font-weight-900'>
          Guarda che innovazione
        </div>
        <div className='mt-5 font-22 line-height-28' style={{ width: 450 }}>
          Dai dati cruciali rilevati alla fattibilità <br />
          della transizione, fino alla reportistica:<br />
          una panoramica sui vantaggi di Fleet Audit.
        </div>
        <div className='mt-12 d-flex justify-content-between' style={{ width: 400 }}>
          <div className='font-family-acumin font-20'>
            04 / 04
          </div>
          <div className='mt-1'>
            <img src={frecciaWhite} alt='Freccia white' />
          </div>
        </div>
      </div>
      <div className='col-6'>
        <div className='lg:mt-13 xl:mt-11 mb-5'>
          <img src={illustration} alt='La mobilità elettrica' className='w-100 h-100' style={{ objectFit: 'contain'}} />
        </div>
      </div>

    </div>
  )
}

export default Page14
